import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "@/lib/cn";

/** `headings.sizes` de `mantine-theme.ts` · h1=28px → h6=13px, pesos y line-heights exactos. */
const ORDER_CLASS = {
  1: "text-[28px] leading-[1.15] font-bold tracking-[-0.02em]",
  2: "text-[22px] leading-[1.25] font-semibold tracking-[-0.015em]",
  3: "text-[18px] leading-[1.35] font-semibold tracking-[-0.01em]",
  4: "text-base leading-[1.4] font-semibold",
  5: "text-sm leading-[1.4] font-semibold",
  6: "text-xs leading-[1.4] font-semibold",
} as const;

export interface HeadingProps extends HTMLAttributes<HTMLHeadingElement> {
  /** Nivel semántico (`<h1>`…`<h6>`) · también decide el tamaño, igual que Mantine `Title order`. */
  order?: 1 | 2 | 3 | 4 | 5 | 6;
}

/** Reemplazo de `<Title order={n}>` de Mantine. */
export const Heading = forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ order = 1, className, ...props }, ref) => {
    const Component = `h${order}` as const;
    return (
      <Component
        ref={ref}
        className={cn(ORDER_CLASS[order], className)}
        {...props}
      />
    );
  }
);
Heading.displayName = "Heading";
